import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { GoogleButton, OrRule } from "./GoogleSignIn";

export interface GuestAcct { name: string; email: string; password: string }

export function useGuestAccount() {
  const { user, register } = useAuth();
  const guest = user === false;
  const [acct, setAcct] = useState<GuestAcct>({ name: "", email: "", password: "" });
  const valid = !guest || (acct.name.trim().length > 1 && /.+@.+\..+/.test(acct.email) && acct.password.length >= 8);
  const ensure = async () => { if (guest) await register(acct.email.trim().toLowerCase(), acct.password, acct.name.trim()); };
  return { guest, acct, setAcct, valid, ensure };
}

export function GuestAccountBlock({ acct, setAcct, tone = "var(--club-dark)", compact = false }: { acct: GuestAcct; setAcct: (a: GuestAcct) => void; tone?: string; compact?: boolean }) {
  const { pathname, search } = useLocation();
  const set = (k: keyof GuestAcct) => (e: React.ChangeEvent<HTMLInputElement>) => setAcct({ ...acct, [k]: e.target.value });
  return (
    <div className={`border p-4 ${compact ? "" : "mt-6"}`} style={{ borderColor: tone, background: "var(--paper)" }} data-testid="guest-account-block">
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <div className="eyebrow" style={{ color: tone }}>Where shall we send it?</div>
        <Link to={`/login?next=${encodeURIComponent(pathname + search)}`} className="text-xs underline underline-offset-4 hover:text-[var(--wine)]" data-testid="guest-signin-link">Already a member? Sign in</Link>
      </div>
      <p className="mt-1 text-xs text-neutral-600">Your details for the order — an account is created so you can track it. No commitment.</p>
      <div className="mt-3"><GoogleButton label="Continue with Google — no password needed" testId="guest-google-button" /></div>
      <OrRule text="or fill in your details" />
      <div className="grid gap-3 sm:grid-cols-2">
        <div className="space-y-1"><Label htmlFor="g-name" className="eyebrow">Your name</Label><Input id="g-name" autoComplete="name" value={acct.name} onChange={set("name")} className="rounded-none bg-transparent" data-testid="guest-name" /></div>
        <div className="space-y-1"><Label htmlFor="g-email" className="eyebrow">Email</Label><Input id="g-email" type="email" autoComplete="email" value={acct.email} onChange={set("email")} className="rounded-none bg-transparent" data-testid="guest-email" /></div>
        <div className="space-y-1 sm:col-span-2"><Label htmlFor="g-pass" className="eyebrow">Choose a password</Label><Input id="g-pass" type="password" autoComplete="new-password" minLength={8} value={acct.password} onChange={set("password")} placeholder="At least 8 characters" className="rounded-none bg-transparent" data-testid="guest-password" /></div>
      </div>
    </div>
  );
}
